<!--发票详情-->
<template>
  <Page class="detailView">
    <div v-if="detailData">
      <div class="pageContent-title">发票详情</div>
      <div class="mt-5">
        <h3 class="font-bold">基本信息</h3>
        <a-form class="form-label-5 flex-form no-gap" labelAlign="left" :form="form">
          <div class="grid grid-cols-4 pl-4">
            <a-form-item label="发票状态">
              <span>{{ translateType$t(detailData.billState, 'billState') }}</span>
            </a-form-item>
            <a-form-item label="旅行社">
              <span>{{ detailData.companyName }}</span>
            </a-form-item>
            <a-form-item label="申请时间">
              <span>{{ detailData.createTime }}</span>
            </a-form-item>
            <a-form-item label="开票时间">
              <span>{{ detailData.billTime }}</span>
            </a-form-item>
          </div>
        </a-form>
        <a-divider></a-divider>
        <h3 class="font-bold">开票信息</h3>
        <a-form class="form-label-5 flex-form no-gap" labelAlign="left" :form="form">
          <div class="grid grid-cols-4 pl-4">
            <a-form-item label="发票金额">
              <span class="text-primary-500">{{ detailData.billAmount }}</span>
            </a-form-item>
            <a-form-item label="发票类型">
              <span>{{ translateType$t(detailData.billType, 'billType') }}</span>
            </a-form-item>
            <a-form-item label="发票性质">
              <span>{{ translateType$t(detailData.billMode, 'billMode') }}</span>
            </a-form-item>
            <a-form-item label="发票抬头">
              <span>{{ detailData.billTitle }}</span>
            </a-form-item>
            <a-form-item label="税号">
              <span>{{ detailData.taxNo }}</span>
            </a-form-item>
            <a-form-item label="地址">
              <span>{{ detailData.address }}</span>
            </a-form-item>
            <a-form-item label="电话">
              <span>{{ detailData.tel }}</span>
            </a-form-item>
            <a-form-item></a-form-item>
            <a-form-item label="开户行">
              <span>{{ detailData.bankName }}</span>
            </a-form-item>
            <a-form-item label="帐户">
              <span>{{ detailData.bankAccount }}</span>
            </a-form-item>
            <a-form-item label="收票邮箱">
              <span>{{ detailData.email }}</span>
            </a-form-item>
            <a-form-item label="收票联系人">
              <span>{{ detailData.contact }}</span>
            </a-form-item>
            <a-form-item label="发票预览" v-if="detailData.billState === 1">
              <el-button type="text" @click="downloadUrl(detailData.billUrl)">下载发票</el-button>
            </a-form-item>
            <a-form-item label="备注" v-if="detailData.billState === 1">
              <span>{{ detailData.remark }}</span>
            </a-form-item>
          </div>

        </a-form>
        <a-divider></a-divider>
      </div>
      <div>
        <h3 class="font-bold">开票订单</h3>
        <a-table
          class="mt-5"
          :rowKey="(record, index) => { return index }"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          :pagination="false"
        ></a-table>
      </div>
      <div class="detailView-actions" v-if="detailData.billState === 0">
        <a-button class="app-btn condition-btns" type="primary" @click="drawBill(detailData)">开票</a-button>
      </div>
    </div>

    <DrawBill ref="DrawBill"></DrawBill>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { toolMixin } from '@/utils/mixin'
import DrawBill from './modules/DrawBill'

export default {
  name: 'BillInfo',
  mixins: [toolMixin],
  components: {
    Page,
    DrawBill,
  },
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {index + 1} </span>
        },
      },
      {
        title: '订单号',
        width: '20%',
        align: 'center',
        dataIndex: 'orderId',
      },
      {
        title: '产品类型',
        width: '15%',
        align: 'center',
        dataIndex: 'productType',
        customRender: (text, row, index) => {
          return <div>{this.translateType$t(text, 'productType')}</div>
        },
      },
      {
        title: '产品名称',
        width: '20%',
        align: 'center',
        dataIndex: 'productName',
      },
      {
        title: '金额',
        width: '10%',
        align: 'center',
        dataIndex: 'orderAmount',
      },
      {
        title: '支付时间',
        width: '15%',
        align: 'center',
        dataIndex: 'createTime',
      },
    ]
    return {
      form: this.$form.createForm(this),
      detailData: null,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
      titleType: this.$route.query.titleType
    }
  },
  computed: {
    typesMap() {
      return {
        productType: [
          { value: 0, label: '证件照' },
          { value: 1, label: '签证产品' },
          { value: 2, label: '制签产品' },
          { value: 3, label: '公证产品' },
        ],
        billState: [
          { value: 0, label: '未开票' },
          { value: 1, label: '已开票' },
        ],
        billType: [{ value: 1, label: '增值税普通电子发票' }],
        billMode: [{ value: 1, label: '电子发票' }],
      }
    },
  },
  mounted() {
    const id = this.$route.query.billId
    this.loadById(id)
  },
  methods: {
    downloadUrl(url) {
      window.open(url, '_blank')
    },
    async loadById(id) {
      this.tableLoading = true
      const res = await this.$axios.get(`/order-web-api/admin/order/bill/${id}`)
      this.detailData = res.data
      this.detailData.titleType = this.titleType
      this.dataSource = res.data.orderBillList.data.content
      this.safeSetFieldsValue$t(this.form, { ...res.data })
      this.tableLoading = false
    },
    async drawBill(row) {
      console.log('row', row);
      await this.$refs.DrawBill.start(row)
      // await this.$refs.DrawBill.start(row)
      this.$message.success('操作成功')
      this.$router.go(-1)
    },
  },
}
</script>

<style>
.audit-status-img {
  width: 105px;
  height: 105px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
</style>
